<template>
  <v-avatar rounded :size="size">
    <span class="ag-first-letter-avatar__container" :class="{ 'ag-first-letter-avatar__section': profileSection }">
      {{ firstLetterByUserName }}
    </span>
  </v-avatar>
</template>

<script>
import UtilsString from '@/utils/UtilsString';
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    profileSection: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    firstLetterByUserName() {
      return UtilsString.firstLetterEachWord(this.name).toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.ag-first-letter-avatar__container) {
  border-radius: 50%;
  background-color: #ffffff;
  color: $brand-color-primary-medium;
  border: 2px solid $brand-color-primary-medium;
  width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}

.ag-first-letter-avatar__section {
  font-size: 50px;
}
</style>
